import './App.css';
import Main from './system/Main'

import React, { useState, useEffect } from 'react';
// import ControllerCursor from 'controller/ControllerCursor';
import Globals from 'system/Globals';


// const socket = io('https://socket.expostudio.co');

function App() {


  return (
    <div className={"App"}>

     
      <Main></Main>  
     


    </div>
  );
}

export default App;
